/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { ReactElement } from 'react';
import { Component } from '@/lib/decorators/component';
import { AttributeDefinition } from '@/lib/decorators/attribute-definition';
import HtmlFragment from '@/components/html-fragment';

@Component('embedCode', {
    name: 'Embed Code',
    group: 'Content',
    description: 'Paste any HTML, script, or embed code to render on the page',
})
// oxlint-disable-next-line react/only-export-components -- PD metadata class co-export
export class EmbedCodeMetadata {
    @AttributeDefinition({
        name: 'Embed Code',
        description: 'Paste HTML, iframe, or script embed code here',
        type: 'text',
    })
    html!: string;
}

interface EmbedCodeProps {
    html?: string;
}

export default function EmbedCode({ html }: EmbedCodeProps): ReactElement | null {
    if (!html) return null;
    return <HtmlFragment content={html} contentType="plain-text" />;
}
